import React, { useEffect } from 'react';
import { ItemForm } from '../../Components/Form';
import FormLayout from '../../Components/Layout/FormLayout';
import { NewItemIcon } from '../../Assets/Navigation/NavigationIcons';
import { t } from 'i18next';

const AddItem = ({ handleToast }) => {
  useEffect(() => {
    document.title = t('Items.add_item');
  }, []);

  return (
    <FormLayout
      title={t('Items.items')}
      Icon={NewItemIcon}
      subtitle={t('common.add_new')}
      closeUrl="/items"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <ItemForm type="add" handleToast={handleToast} />
    </FormLayout>
  );
};

export default AddItem;
